import { fetchBaseQuery } from '@reduxjs/toolkit/dist/query'
import { getCSRFToken } from '@view/utils/getCSRFToken'

export function baseApi(baseUrl: string) {
	return {
		baseQuery: fetchBaseQuery({
			prepareHeaders: (headers, { type }) => {
				if (type === 'mutation') {
					headers.set('X-CSRF-Token', getCSRFToken())
				}
				headers.set('x-react', 'useReact')
				return headers
			},
			baseUrl,
		}),
	}
}

export const controllerHeaders = {}
/*  */

export type ServiceHeadersType = {
	token?: string
	headers?: {}
	customConfig?: {}
}
